<template>
  <v-card
    v-bind:style="{ background: background }"
    elevation="1"
    height="100%"
    width="100%"
  >
    <v-card-title class="form-title pa-0" fluid v-if="!this.disabled">
      <v-row
        no-gutters
        width="100%"
        style="display: flex; justify-content: space-between"
        align="center"
      >
        <v-col cols="1" v-if="center"></v-col>
        <v-col
          cols="7"
          class="text-left"
          v-bind:class="[{ 'justify-center': center }, 'd-flex']"
        >
          <span
            class="break-word ml-3"
            v-bind:class="{ headline: !smaller, 'subtitle-1': smaller }"
            v-bind:style="{ color: headerColor }"
          >
            {{ expandForm ? '' : title }} </span
          ><span
            class="red--text break-word"
            v-bind:class="{ headline: !smaller, 'subtitle-1': smaller }"
            >{{ expandForm || error == null ? '' : `  (${error})` }}</span
          >
          <slot name="titleTooltip"></slot>
        </v-col>
        <v-col cols="1" id="right-col">
          <slot name="beforeExpandButton"></slot>
          <v-btn icon v-on:click="expandForm = !expandForm">
            <v-icon color="grey darken-1" v-if="expandForm">expand_less</v-icon>
            <v-icon color="grey darken-1" v-if="!expandForm">
              expand_more
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-expand-transition>
      <div v-show="expandForm">
        <v-row dense v-if="!error && values">
          <v-col
            v-for="mainColumn in structure"
            :key="mainColumn.title"
            dense
            v-bind:class="[{ 'justify-center': center }, 'd-flex']"
          >
            <v-card
              elevation="0"
              height="100%"
              width="80%"
              v-bind:style="{ background: background }"
            >
              <v-card-title v-if="mainColumn.title">
                <span
                  class="Title1 break-word"
                  v-bind:style="{ color: titleColor }"
                >
                  {{ mainColumn.title }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-row
                  v-for="(line, index) in mainColumn.data"
                  :key="`${mainColumn.title}-${index}`"
                  dense
                  v-if="
                    line.filter((column) => values[column.dataField] != null)
                      .length !== 0 && !oneLine
                  "
                >
                  <v-col
                    v-for="column in line"
                    :key="column.field"
                    v-if="values[column.dataField]"
                    dense
                  >
                    <v-row
                      dense
                      v-bind:class="[{ 'justify-center': center }, 'd-flex']"
                    >
                      <span
                        v-bind:style="{
                          color: subtitleColor,
                          'font-size': column.fontsize
                        }"
                      >
                        {{ column.label }}
                      </span>
                    </v-row>
                    <v-row
                      dense
                      v-bind:class="[{ 'justify-center': center }, 'd-flex']"
                    >
                      <span
                        v-bind:style="{
                          color: valuesColor,
                          'font-size': column.fontsize
                        }"
                      >
                        {{
                          column.displayFunc
                            ? column.displayFunc(column)
                            : displayValue(column)
                        }}
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  v-for="(line, index) in mainColumn.data"
                  :key="`${mainColumn.title}-${index}`"
                  dense
                  v-if="
                    line.filter((column) => values[column.dataField] != null)
                      .length !== 0 && oneLine
                  "
                >
                  <v-col
                    v-for="column in line"
                    :key="column.field"
                    v-if="values[column.dataField]"
                    dense
                  >
                    <v-row
                      dense
                      v-bind:class="[{ 'justify-center': center }, 'd-flex']"
                    >
                      <span
                        v-bind:style="{
                          display: 'inline',
                          color: subtitleColor,
                          'font-size': column.fontsize
                        }"
                      >
                        {{ column.label + ':&nbsp;&nbsp;' }}
                      </span>
                      <span
                        v-bind:style="{
                          display: 'inline',
                          color: valuesColor,
                          'font-size': column.fontsize
                        }"
                      >
                        {{
                          column.displayFunc
                            ? column.displayFunc(column)
                            : displayValue(column)
                        }}
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row dense v-else>
          <div
            v-if="!error && !values"
            style="
              width: 100%;
              height: 260px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
            v-bind:style="{
              color: emptyColor
            }"
          >
            {{ emptyMessage }}
          </div>
          <div
            v-else
            class="red--text"
            style="
              width: 100%;
              height: 260px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            {{ error }}
          </div>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import dataTools from '../../tools/data'
export default {
  name: 'ExpandableTLECard',
  props: {
    root: {
      type: Object
    },
    isExpanded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    smaller: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    emptyMessage: {
      type: String,
      default: 'Copy-paste a TLE to display its details'
    },
    values: {
      type: Object,
      default: null
    },
    error: {
      type: String,
      default: null
    },
    background: {
      type: String,
      default: ''
    },
    headerColor: {
      type: String,
      default: ''
    },
    titleColor: {
      type: String,
      default: ''
    },
    subtitleColor: {
      type: String,
      default: '#9e9e9e'
    },
    valuesColor: {
      type: String,
      default: ''
    },
    emptyColor: {
      type: String,
      default: 'grey'
    },
    centered: {
      type: Boolean,
      default: false
    },
    oneLine: {
      type: Boolean,
      default: true
    },
    structure: {
      type: Array,
      default: () => [
        {
          title: 'Spacecraft',
          data: [
            [{ label: 'Name', dataField: 'name' }],
            [{ label: 'Number', dataField: 'number' }],
            [{ label: 'Classification', dataField: 'classification' }],
            [{ label: 'Launch details', dataField: 'launchdetails' }],
            [{ label: 'Revolution counts at TLE date', dataField: 'revcount' }]
          ]
        },
        {
          title: 'Osculating Orbit',
          data: [
            [{ label: 'Frame', dataField: 'frame' }],
            [
              {
                label: 'Date (UTC)',
                dataField: 'orbitDateTime'
              }
            ],
            [
              {
                label: 'Semi Major Axis',
                dataField: 'sma',
                type: 'distance'
              },
              {
                label: 'Eccentricity',
                dataField: 'eccentricity',
                type: 'coefficient'
              }
            ],
            [
              {
                label: 'Inclination',
                dataField: 'inclination',
                type: 'angle'
              },
              {
                label: 'RAAN',
                dataField: 'raan',
                type: 'angle'
              }
            ],
            [
              {
                label: 'Arg. of Perigee',
                dataField: 'perigeeArgument',
                type: 'angle'
              },
              {
                label: 'Mean Anomaly',
                dataField: 'anomaly',
                type: 'angle'
              }
            ]
          ]
        }
      ]
    }
  },

  data() {
    return {
      expandForm: this.isExpanded,
      center: this.centered
    }
  },

  methods: {
    displayValue(column) {
      if (column.small) {
        return this.displaySmallValue(column)
      } else {
        return this.getValue(column)
      }
    },
    displaySmallValue(column) {
      const value = this.values[column.dataField]
      if (value === '' || value == null || value === undefined) {
        return ''
      }
      const convertedValue = dataTools.convertSi2gui(
        column.type,
        this.values[column.dataField]
      )
      let result
      if (column.type === 'date' || Math.abs(convertedValue) >= 0.1) {
        result = dataTools.convertSi2gui(
          column.type,
          this.values[column.dataField]
        )
        result = dataTools.displayNdigits(result, 3)
        result = result === '-0' ? '0' : result
      } else {
        result = convertedValue.toExponential(3)
      }
      const unit = dataTools.getUnitDisplayed(
        dataTools.getDefaultGuiUnit(column.type)
      )
      return unit ? `${result} ${unit}` : result
    },
    getValue(column) {
      const value = dataTools.convertSi2Display(
        column.type,
        this.values[column.dataField]
      )
      const unit = dataTools.getUnitDisplayed(
        dataTools.getDefaultGuiUnit(column.type)
      )
      return unit ? `${value} ${unit}` : value
    }
  },
  computed: {
    backgroundDescriptionStyle() {
      return ' background-color: rgba(255, 255, 255, 0.1);'
    }
  },

  watch: {
    expandForm() {
      this.$emit('expand', this.expandForm)
      if (this.expandForm) {
        setTimeout(() => {
          this.root.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          })
        }, 400)
      }
    },
    isExpanded(val) {
      this.expandForm = val
    }
  }
}
</script>
<style lang="scss" scoped>
.form-title {
  display: flex;
  justify-content: space-between;
  #right-col {
    display: flex;
    align-items: center;
    justify-content: end;
    >>> .row {
      justify-content: end;
    }
  }
}

.caption {
  width: fit-content;
}

>>> .break-word {
  word-break: break-word;
}

>>> .expand-transition-enter-active,
>>> .expand-transition-leave-active {
  transition: all 0.3s ease-in-out !important;
}
</style>
